import { EventEmitter } from 'events';

const eventEmitter: EventEmitter = new EventEmitter();

export default eventEmitter;